
import { Component, Vue } from 'vue-property-decorator'
import http from '@/utils/request'
import { getUserInfo } from '@/utils/user'
import SkeletonLoader from './component/skeleton-loader.vue'
import IndividualLender from './IndividualLender.vue'
import dialogSelect from './component/dialog-select-insurance.vue'
import { loanPurposeVal } from './data'
import { isNullOrUndefined } from '@/utils'
import { borrowerGender, riskLevelLabels, fundChannel, married, lengthOfStay, lengthOfWorking } from '@/utils/dictionary'
import { date } from '@/filters/date'

@Component({
  components: { SkeletonLoader, IndividualLender, dialogSelect }
  })
export default class extends Vue {
  private isLoading = false
  private tableData = []
  individualLenderData = null
  openSelectInsurance = false
  openCannotBuy = false
  activeCards = ['product', 'borrower', 'lender', 'insurance'] // Default: semua card terbuka

  list: any = {
    rate: 0,
    //
    lendNo: '',
    lid: '',
    contractAmount: '',
    interest: ''
  }

  insurance: any = {
    insuranceName: '',
    policyNumber: ''
  }

  insuranceChannel = 0
  qoalaStatus: any = ''
  manulBuyDidsButtonDisabled = false
  private showWarningDialog = false
  private projectionMessage = false
  private warningMessage = false
  private theTitle = 'Potential Limit Breach!'
  private showContinueOption = false

  private tab = {
    background: '#eef1f6',
    color: '#606266'
  }

  signVos = []
  thirdPartySrc = ''
  showThirdPartyDialog = false
  showIndividualLender = false
  ojkialogVisible = false

  checkManulBuyDidsButtonDisabled() {
    const { mid } = getUserInfo('userInfoMap')
    if (this.list.fundChannel === null && mid === 10003) {
      this.manulBuyDidsButtonDisabled = false
      return
    }
    const channel = fundChannel.find(item => item.label === String(this.list.fundChannel))
    if (channel && channel.mid === mid) {
      this.manulBuyDidsButtonDisabled = false
    } else {
      this.manulBuyDidsButtonDisabled = true
    }
  }

  created() {
    this.qoalaStatus = this.$route.query.qoalaStatus
    this.getList()
    this.getInfo()
  }

  closeIndividualLender(val: boolean) {
    if (val) {
      this.showIndividualLender = false
      this.manulBuyDidsButtonDisabled = true
      this.getList()
    }
  }

  purposeOfLoan() {
    const arr = loanPurposeVal
    for (let index = 0; index < arr.length; index++) {
      if (+this.list.loanPurpose === arr[index].val) {
        this.list.loanPurpose = arr[index].label
      }
    }
  }

  async getList() {
    this.isLoading = true
    try {
      const response = await http.post('/lend/api/queryLendDetail', {
        lid: this.$route.query.lid
      })
      this.list = response
      this.purposeOfLoan()
      this.list.rate = this.list.rate / 10000
      this.checkManulBuyDidsButtonDisabled()
      // Debug: Log photo URL
      console.log('Photo URL:', this.list.photo)
    } catch (error) {
      /** Cancel action */
    } finally {
      this.isLoading = false
    }
  }

  getInfo() {
    http
      .post('/lend/api/insurance/info', {
        cameraId: this.$route.query.cameraId
      })
      .then((response) => {
        this.insurance = response
      })
      .catch(() => {
        /** Cancel action */
      })
  }

  async manulBuyBids(): Promise<void> {
    const { mid: customerId } = getUserInfo('userInfoMap')
    const data = await http.post('/lend/api/os/info', { lendCustomerId: customerId })
    if (data.flag) {
      this.isInsurance()
    } else {
      this.ojkialogVisible = true
    }
  }

  isInsurance() {
    this.ojkialogVisible = false
    this.openSelectInsurance = true
  }

  async getIndividualLender(e: any) {
    this.insuranceChannel = isNullOrUndefined(e) ? 0 : e
    this.openSelectInsurance = false
    const detailLoading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    try {
      const { mid: customerId } = getUserInfo('userInfoMap')
      if (e) {
        await this.createInsurance()
      }
      await http.post('/lend/manulBuyBids', {
        customerId,
        lids: [this.$route.query.lid],
        insuredChannel: e
      })
      await this.urlRouter()
      this.getList()
    } catch (error) {
      //
    } finally {
      detailLoading.close()
    }
  }

  async urlRouter() {
    const signVos = [
      {
        cameraId: this.list.lendNo,
        lendAmount: this.list.contractAmount,
        interestAmount: this.list.interest,
        loanBusiId: this.list.lid,
        qoalaStatus: 2
      }
    ]

    const { insuranceChannel: insurance } = this

    const userType = '1'

    await http
      .post('/sign/sendDocument', {
        signVos,
        insurance,
        userType
      })
      .then((data) => {
        if (data.status === 'Succeed') {
          this.thirdPartySrc = data.link
          this.showThirdPartyDialog = true
        } else if (data.qianming) {
          this.individualLenderData = { ...data }
          this.showIndividualLender = true
        } else {
          this.$message.error(data.digisignMsg)
        }
      })
  }

  async createInsurance() {
    return new Promise((resolve) => {
      let isDone = false
      const params = {
        lids: [this.list.lid],
        cameraId: this.list.lendNo,
        insuranceChannel: this.insuranceChannel
      }
      http
        .post('/lend/api/insurance/create', params)
        .then(() => {
          // console.log(response)
          isDone = true
        })
        .catch(() => {
          // Handle error silently
        })
        .finally(() => {
          resolve(true)
        })

      setTimeout(() => {
        if (!isDone) {
          console.log('insurance create request time out.')
          resolve(true)
        }
      }, 8e3)
    })
  }

  continuePurchase() {
    this.showWarningDialog = false
    this.openSelectInsurance = true
  }

  /**
   * Handle continue purchase after limit warning
   * When user clicks "Lanjutkan" button in warning dialog
   */
  cancelPurchase() {
    this.showWarningDialog = false
  }

  getRiskLevelLabel(riskLevel: string): string {
    const risk = riskLevelLabels.find(item => item.value === riskLevel)
    return risk ? String(risk.label) : riskLevel || ''
  }

  getRiskLevelClass(riskLevel: string): string {
    const risk = riskLevelLabels.find(item => item.value === riskLevel)
    const label = risk ? String(risk.label).toLowerCase() : riskLevel.toLowerCase()
    if (label.includes('low') || label.includes('rendah')) {
      return 'risk-low'
    } else if (label.includes('medium') || label.includes('sedang')) {
      return 'risk-medium'
    } else if (label.includes('high') || label.includes('tinggi')) {
      return 'risk-high'
    }
    return 'risk-medium' // default
  }

  getLengthOfStayLabel(stayValue: string): string {
    const lengthItem = lengthOfStay.find(item => item.value === stayValue)
    return lengthItem ? String(lengthItem.label) : stayValue || ''
  }

  getLengthOfWorkingLabel(workValue: number): string | number {
    const workItem = lengthOfWorking.find(item => item.value === workValue)
    return workItem ? String(workItem.label) : workValue || ''
  }

  getGenderLabel(genderValue: string): string {
    const genderItem = borrowerGender.find(item => item.value === genderValue)
    return genderItem ? String(genderItem.label) : genderValue || ''
  }

  getMaritalStatusLabel(maritalValue: string): string {
    const valueMap: { [key: string]: string } = {
      unmarried: 'L',
      married: 'M',
      divorced: 'J',
      widowed: 'D'
    }

    const mappedValue = valueMap[maritalValue] || maritalValue
    const maritalItem = married.find(item => item.value === mappedValue)
    return maritalItem ? String(maritalItem.label) : maritalValue || ''
  }

  /**
   * Format birthday timestamp to readable date
   */
  formatBirthday(timestamp: number): string {
    if (!timestamp) return ''
    return date(timestamp)
  }

  /**
   * Handle image error when loading photo
   */
  handleImageError(error: any): void {
    console.error('Error loading image:', error)
    console.log('Image URL that failed:', this.list.photo)
  }
}
